import { vuexfireMutations, firestoreAction } from "vuexfire";
import { reliabilitiesCollection, db } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    reliabilityList: [],
    reliabilityProfile: {},
    reliabilities: [],
    lastReliability: []
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    callReliabilities: context => {
      context.dispatch("bindReliabilities");
    },
    bindReliabilities: firestoreAction(context => {
      return context.bindFirestoreRef(
        "reliabilityList",
        reliabilitiesCollection
      );
    }),
    bindRealibilityOfEquipment: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "reliabilities",
        reliabilitiesCollection
          .where("equipmentProfile", "==", db.doc(`equipments/${id}`))
          .orderBy("dateCreated")
      );
    }),
    bindAReliability: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "reliabilityProfile",
        reliabilitiesCollection.doc(id)
      );
    }),
    bindLastReliability: firestoreAction((context, id) => {
      try {
        return context.bindFirestoreRef(
          "lastReliability",
          reliabilitiesCollection
            .where("equipmentProfile", "==", db.doc(`equipments/${id}`))
            .orderBy("datetime", "desc")
            .limit(1)
        );
      } catch (err) {
        console.log(err);
      }
    })
  },
  getters: {}
};
